export const GET_SYSTEMS = 'GET_SYSTEMS';
export const SYSTEMS_UPDATED = 'SYSTEMS_UPDATED';